<template>
  <div class="flex flex-col items-center justify-center space-y-12">
    <h2 class="text-xl font-semibold">Our Bestsellers</h2>
    <div class="grid grid-cols-2 gap-4">
      <div
        v-for="(card, index) in cards"
        :key="index"
        class="flex h-44 w-44 flex-col items-center justify-center space-y-4 rounded bg-white px-4 lg:h-52 lg:w-52 xl:h-64 xl:w-64"
      >
        <div class="flex h-20 flex-col justify-center xl:h-24">
          <NuxtImg
            :src="card.imgSrc"
            :alt="card.altText"
            class="text-grays-darkest"
          />
        </div>
        <h3
          class="text-grays-darkest whitespace-nowrap text-center font-semibold lg:text-lg"
        >
          {{ card.title }}
        </h3>
        <span class="text-grays-dark">{{ card.productCode }}</span>
      </div>
    </div>
    <span>*Not Available for all Plans</span>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const cards = ref([
  {
    imgSrc: '/img/welcome/welcome-vision1.png',
    altText: 'Square Glasses',
    title: 'Square Glasses',
    productCode: '#2020123',
  },
  {
    imgSrc: '/img/welcome/welcome-vision4.jpg',
    altText: 'Kids’ Flexible Rectangle Glasses',
    title: 'Kids’ Flexible',
    productCode: '#2021712',
  },
  {
    imgSrc: '/img/welcome/welcome-vision2.png',
    altText: 'Square glasses',
    title: 'Square Glasses',
    productCode: '#126016',
  },
  {
    imgSrc: '/img/welcome/welcome-vision3.jpg',
    altText: 'Cat-Eye Glasses',
    title: 'Cat-Eye Glasses',
    productCode: '#7828024',
  },
])
</script>
